import SharedStyles from "./Profile.styles";

export default (theme) => {
	const sharedStyles = SharedStyles(theme);
	return Object.assign(sharedStyles, {
		chipRed: {
			color: "#b71c1c",
			backgroundColor: "#ffebee",
			cursor: "pointer",
		},
		iconRed: {
			color: "#b71c1c",
		},
	});
};
